export default class ConfettiContainer {
    constructor(skin) {
        this._skin = skin;
    }

    play() {
        this._skin.gotoAndStop(0); // ensure that children array is populated
        for (let i = 0; i < this._skin.children.length; i++) {
            const screenHeight = 1080; // WISH: remove hardcoded
            const halvedScreenHeight = screenHeight * .5;
            const padding = 200;
            const paddedHalvedScreenHeight = halvedScreenHeight + padding;

            const child = this._skin.children[i];
            const initialRotation = Math.random() * 360;
            const initialPosition = child.y;

            // Set random anchoring
            const childBounds = child.getBounds();
            child.regX = Math.random() * childBounds.width;
            child.regY = Math.random() * childBounds.height;

            // Animate rotation and fall
            child.rotation = initialRotation;
            child.y = -paddedHalvedScreenHeight;

            createjs.Tween.get(child, { loop: -1 })
                .to({ rotation: initialRotation + 360 }, 1450 + Math.random() * 650);

            createjs.Tween.get(child, { loop: -1 })
                .wait(i * 300)
                .to({ y: paddedHalvedScreenHeight }, 4000 + Math.random() * 6000);
        }
    }

    stop() {
        for (let i = 0; i < this._skin.children.length; i++) {
            const child = this._skin.children[i];
            createjs.Tween.removeTweens(child);
        }
    }
}